
  <button
    class="kebab-menu-button d-flex align-items-center bg-white clickable border-none border-radius-2 justify-center h-{{height}}-px w-{{width}}-px"
    nz-dropdown [nzDropdownMenu]="kebabMenu" [nzVisible]="isVisible" [nzPlacement]="menuPlacement"
    [nzDisabled]="isDisabled" [nzTrigger]="menuTrigger" [nzClickHide]="hideOnClick" (nzVisibleChange)="onToggleDropdown()">
    <i class="d-flex"><svg    width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM6 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM1 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" fill="#5E5E5E"/></svg></i>
  </button>

  <nz-dropdown-menu #kebabMenu="nzDropdownMenu">
    <ul class="kebab-menu py-4-imp px-0-imp border-radius-4" nz-menu>
      <ng-container *ngFor="let option of menuOptions">
        <li *ngIf="option.isOptionDivider" class="kebab-menu-divider" nz-menu-divider></li>
        <li *ngIf="!option.isOptionDivider && !option.isHidden" nz-menu-item
          class="d-flex align-items-center clickable py-7-imp px-12-imp"
          [class.kebab-menu-option]="!option.isDisabled"
          [class.red-50-imp]="option.labelType === labelType.DANGER"
          [nzDisabled]="option.isDisabled"
          (click)="onOptionSelect(option)"
        >{{option.label}}</li>
      </ng-container>
    </ul>
  </nz-dropdown-menu>
